import { cx } from '@emotion/css';

import { ApplicationCardProps } from './types';
import { applicationCardCx } from './styles';

const ApplicationCard = (props: ApplicationCardProps) => {
  const { children, className, ...resProps } = props;

  return (
    <div
      className={cx('application-card', applicationCardCx, className)}
      {...resProps}
    >
      {children}
    </div>
  );
};

export default ApplicationCard;
